import axios from 'axios';
import { ApiResponse, ExamSession } from '../../../shared/types';

const API_BASE = '/api/v1/exam-session';

class ExamSessionService {
  async getExamSessions(): Promise<ApiResponse<ExamSession[]>> {
    const response = await axios.get<ApiResponse<ExamSession[]>>(API_BASE);
    return response.data;
  }

  async createExamSession(data: any): Promise<ApiResponse> {
    const response = await axios.post<ApiResponse>(API_BASE, data);
    return response.data;
  }

  async updateExamSession(id: number, data: any): Promise<ApiResponse> {
    const response = await axios.put<ApiResponse>(`${API_BASE}/${id}`, data);
    return response.data;
  }

  async deleteExamSession(id: number): Promise<ApiResponse> {
    const response = await axios.delete<ApiResponse>(`${API_BASE}/${id}`);
    return response.data;
  }

  async getStudentsForSession(id: number): Promise<ApiResponse<any[]>> {
    const response = await axios.get<ApiResponse<any[]>>(`${API_BASE}/${id}/students`);
    return response.data;
  }

  async getExamSessionById(id: number): Promise<ApiResponse<ExamSession>> {
    const response = await axios.get<ApiResponse<ExamSession>>(`${API_BASE}/${id}`);
    return response.data;
  }
}

export default new ExamSessionService(); 